<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
				<div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
					<BackLink/>
          <Section :section="this.question.sectionId" />
				</div>
        <Form
          :data="form"
          :error="$v.form.$error"
          :formId="question.id"
          :formErrorMessage="errorMessage"
          @submit="submitDateOfBirth"
        >
          <DateOfBirth 
						:validate="$v.form"
						:errorMessage="errorMessage">
            
            <DateOfBirthInput
              id="day"
              name="day"
              label="Day"
              type="day"
              v-model="form.day"
              :validate="$v.form"
            />
            <DateOfBirthInput
              id="month"
              name="month"
              label="Month"
              type="month"
              v-model="form.month"
              :validate="$v.form"
            />
            <DateOfBirthInput
              id="year"
              name="year"
              label="Year"
              type="year"
              v-model="form.year"
              :validate="$v.form"
            />
          </DateOfBirth>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>

// Having issue with having to hit submit twice

import { required, maxValue, minValue } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "home",
  props: {
    title: String
  },
  data() {
    return {
      selected: null,
      question: {},
      errorMessage: "Please enter your date of birth, ensure it is a valid date & age of 14 year or older.",
      age: 0,
      form: {
        day: null,
        month: null,
        year: null
      }
    };
  },
  created() {
    this.loadQuestion();
  },
  validations: {
    form: {
			checkDate(){
				return (
					this.isValidDate(this.form.day, this.form.month, this.form.year) && 
          this.isValidAge()
				);
			},
      day: { required, minValue: minValue(1), maxValue: maxValue(31)},
      month: { required, minValue: minValue(1), maxValue: maxValue(12)},
			year: { required, minValue: minValue(1900), maxValue: maxValue(new Date().getFullYear())}
    }
	},
  methods: {
		daysInMonth(m, y) {
			switch (m) {
				case 1 :
					return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
				case 8 : case 3 : case 5 : case 10 :
					return 30;
				default :
					return 31
			}
		},
		isValidDate(d, m, y) {
			m = parseInt(m, 10) - 1;
			return m >= 0 && m < 12 && d > 0 && d <= this.daysInMonth(m, y);
		},
    isValidAge() {
      let birthDate = new Date(this.form.year, this.form.month-1, this.form.day);
      return (this.calculateAge(birthDate) >= 14);
    },
    calculateAge(birthDate) {
      let today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      if (today.getMonth() < birthDate.getMonth() || (today.getMonth() == birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    submitForm(form, valid) {
			valid.$touch();
      if (valid.$pending || valid.$error) {
				setTimeout(() => {
					document.querySelector(".error-summary__link").focus()
				}, 0);
				return;	
			}
      let year = form.year.toString();
      let month = form.month.toString();
      let day = form.day.toString();
      let birthDate = new Date(year, month-1, day);
      this.age = this.calculateAge(birthDate);
      let newLocation = this.question.destination;
      this.logResponse();
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: newLocation.toLowerCase() });
            }
    },
    submitDateOfBirth() {
      this.submitForm(this.form, this.$v.form);
    },
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.question = currentQuestion;
      let previousResponse = dataService.wasAnsweredBefore(currentQuestion.id);
      if (previousResponse) {
        this.form.day = previousResponse.day;
        this.form.month = previousResponse.month;
        this.form.year = previousResponse.year;
      }
    },
    logResponse() {
      let response = {
        id: this.question.id,
        questionType: "DateOfBirth",
        responseId: this.age,
        response: "You have declared that you are " + this.age + " years old",
        day: this.form.day,
        month: this.form.month,
        year: this.form.year
      };
      dataService.logResponse(response);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>